var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "lvmama_goods_nav_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", { staticClass: "label" }, [_vm._v("选择菜单")]),
      _c(
        "el-form-item",
        {
          attrs: {
            rules: [{ required: true, message: "菜单不可为空" }],
            prop: "category_id",
          },
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: "请选择菜单",
                clearable: "",
                filterable: "",
              },
              on: { change: _vm.changeCategory },
              model: {
                value: _vm.value.config.category_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "category_id", $$v)
                },
                expression: "value.config.category_id",
              },
            },
            _vm._l(_vm.menuListFilter, function (menu) {
              return _c("el-option", {
                key: menu.id,
                attrs: {
                  label: menu.show_name,
                  value: menu.id,
                  disabled: menu.disabled,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "label" }, [
        _vm._v(" 设置分类及排序 "),
        _c("span", { staticClass: "tips" }, [
          _vm._v("（C端展示以分类数据为准）"),
        ]),
      ]),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.handleDialogVisible } },
        [_vm._v("编辑分类数据及排序")]
      ),
      _c(
        "div",
        { staticClass: "category_box" },
        [
          _vm._v(" 分类数据： "),
          _vm._l(_vm.value.config.value, function (item, index) {
            return _c("span", { key: index }, [
              _vm._v(" " + _vm._s(index === 0 ? "" : "、") + " "),
              _c("span", { class: [!item.flag && "close"] }, [
                _vm._v(" " + _vm._s(item.name) + " "),
              ]),
            ])
          }),
        ],
        2
      ),
      _c("div", {
        staticStyle: {
          height: "2px",
          "background-color": "#eaeaea",
          "margin-bottom": "20px",
          "margin-top": "20px",
        },
      }),
      _c(
        "el-form-item",
        {
          attrs: {
            rules: [{ required: true, message: "选项不可为空" }],
            prop: "extend_sort",
          },
        },
        [
          _vm._v(" 个性化排序 "),
          _c("el-switch", {
            attrs: { "active-value": 1, "inactive-value": 0 },
            model: {
              value: _vm.value.config.extend_sort,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "extend_sort", $$v)
              },
              expression: "value.config.extend_sort",
            },
          }),
          _c(
            "div",
            { staticClass: "tips", staticStyle: { "line-height": "1" } },
            [_vm._v(" 关闭后，默认使用综合排序 ")]
          ),
        ],
        1
      ),
      _c("div", {
        staticStyle: {
          height: "2px",
          "background-color": "#eaeaea",
          "margin-bottom": "20px",
          "margin-top": "20px",
        },
      }),
      _c(
        "div",
        { staticClass: "sort line_number" },
        [
          _c(
            "div",
            { staticClass: "label" },
            [
              _vm._v(" 商品列表显示模式 "),
              _c(
                "el-tooltip",
                { attrs: { effect: "dark", placement: "top" } },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      " 选择「显示固定行数的商品」，表示共显示所设行数的商品，可控制底下是否显示查看更多；"
                    ),
                    _c("br"),
                    _vm._v(
                      "选择「上滑无限加载商品」，表示每次上滑加载所设行数的商品。 "
                    ),
                  ]),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v(" 说明 "),
                    _c("i", { staticClass: "el-icon el-icon-warning-outline" }),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [
                  {
                    required: true,
                    validator: function (rule, value, callback) {
                      return _vm.checkNumber(rule, value, callback)
                    },
                    trigger: "change",
                  },
                ],
                prop: "line_number",
              },
            },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入商品展示行数" },
                  model: {
                    value: _vm.value.config.line_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "line_number", $$v)
                    },
                    expression: "value.config.line_number",
                  },
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("显示")]),
                  _c("template", { slot: "append" }, [_vm._v("行")]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [
                  {
                    required: true,
                    trigger: "change",
                  },
                ],
                prop: "list_show_type",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.list_show_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "list_show_type", $$v)
                    },
                    expression: "value.config.list_show_type",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(" 显示固定行数的商品 "),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                              },
                            ],
                            prop: "list_show_more",
                          },
                        },
                        [
                          _vm._v(" 底部显示「查看更多」按钮 "),
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.value.config.list_show_more,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.value.config,
                                  "list_show_more",
                                  $$v
                                )
                              },
                              expression: "value.config.list_show_more",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(" 上滑无限加载商品 "),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", {
        staticStyle: {
          height: "2px",
          "background-color": "#eaeaea",
          "margin-bottom": "10px",
          "margin-top": "20px",
        },
      }),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c("div", {
        staticStyle: {
          height: "2px",
          "background-color": "#eaeaea",
          "margin-bottom": "10px",
          "margin-top": "20px",
        },
      }),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.dialogVisible, width: "470px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "500px", "overflow-y": "scroll" } },
            [
              _c(
                "draggable",
                {
                  attrs: { animation: "500", "force-fallback": true },
                  model: {
                    value: _vm.editConfig,
                    callback: function ($$v) {
                      _vm.editConfig = $$v
                    },
                    expression: "editConfig",
                  },
                },
                _vm._l(_vm.editConfig, function (item, index) {
                  return _c(
                    "div",
                    { key: item.id, class: ["box", !item.flag && "disabled"] },
                    [
                      _c(
                        "div",
                        { staticClass: "list" },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(" " + _vm._s(item.primitiveName) + " "),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { margin: "0" },
                              attrs: { prop: "value." + index + ".flag" },
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                },
                                on: { change: _vm.changeSwitch },
                                model: {
                                  value: item.flag,
                                  callback: function ($$v) {
                                    _vm.$set(item, "flag", $$v)
                                  },
                                  expression: "item.flag",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "list" },
                        [
                          _c("div", { staticClass: "label nickName" }, [
                            _vm._v(" 展示为 "),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "value." + index + ".name",
                                rules: [
                                  {
                                    required: true,
                                    validator: function (
                                      rule,
                                      value,
                                      callback
                                    ) {
                                      return _vm.checkList(
                                        "name",
                                        value,
                                        callback,
                                        item.flag
                                      )
                                    },
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", disabled: !item.flag },
                                model: {
                                  value: item.name,
                                  callback: function ($$v) {
                                    _vm.$set(item, "name", $$v)
                                  },
                                  expression: "item.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.value.config.is_open_sub_name === "1"
                        ? _c(
                            "div",
                            { staticClass: "list" },
                            [
                              _c("div", { staticClass: "label nickName" }, [
                                _vm._v(" 副标题 "),
                              ]),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "value." + index + ".sub_name",
                                    rules: [
                                      {
                                        min: 1,
                                        max: 15,
                                        message: "副标题长度为1-15个字",
                                      },
                                      {
                                        required: true,
                                        validator: function (
                                          rule,
                                          value,
                                          callback
                                        ) {
                                          return _vm.checkList(
                                            "sub_name",
                                            value,
                                            callback,
                                            item.flag
                                          )
                                        },
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      disabled: !item.flag,
                                      placeholder: "可输入1-15个字",
                                    },
                                    model: {
                                      value: item.sub_name,
                                      callback: function ($$v) {
                                        _vm.$set(item, "sub_name", $$v)
                                      },
                                      expression: "item.sub_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmDialogVisible },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }